import { useId } from 'react';
import type { InputHTMLAttributes } from 'react';

interface TextFieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'id'> {
  label: string;
  /** Ya traducido. */
  error?: string | undefined;
  hint?: string | undefined;
}

/**
 * Campo de texto con etiqueta, pista y error enlazados por id.
 *
 * `aria-invalid` y `aria-describedby` no son decoración: sin ellos un lector de pantalla
 * anuncia el campo sin decir que está mal ni por qué.
 */
export function TextField({ label, error, hint, className, ...inputProps }: TextFieldProps) {
  const id = useId();
  const hintId = `${id}-hint`;
  const errorId = `${id}-error`;
  const describedBy = [hint ? hintId : null, error ? errorId : null].filter(Boolean).join(' ');

  return (
    <div className="mb-4">
      <label className="mb-1.5 block text-sm font-semibold" htmlFor={id}>
        {label}
      </label>
      <input
        {...inputProps}
        id={id}
        className={['campo', className].filter(Boolean).join(' ')}
        aria-invalid={error ? 'true' : undefined}
        aria-describedby={describedBy === '' ? undefined : describedBy}
      />
      {hint ? (
        <span className="mt-1 block text-xs text-tenue" id={hintId}>
          {hint}
        </span>
      ) : null}
      {error ? (
        <span className="campo-error mt-1 block text-sm text-alerta" id={errorId}>
          {error}
        </span>
      ) : null}
    </div>
  );
}
